import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=f05289ea&scoped=true&"
import script from "./Links.vue?vue&type=script&lang=ts&"
export * from "./Links.vue?vue&type=script&lang=ts&"
import style0 from "./Links.vue?vue&type=style&index=0&id=f05289ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05289ea",
  null
  
)

export default component.exports